import { DefineOwnModule, RootActions } from 'stores/type';
import EventsManager from 'managers/events.manager';
import TextTutorialsManager from 'managers/text-tutorials.manager';
import StorageManager, { StorageKey } from 'managers/storage.manager';
import { State, Getters, Actions, Mutations } from './types';


const moduleState: State = {
  tutorial: null,
  tutorialsFinished: false,

  currentText: null,
  currentTextPosition: null,
  shownText: [],

  ...StorageManager.load(StorageKey.TUTORIALS),
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions & Pick<RootActions, 'resetProgress'>> = {
  state: moduleState,

  getters: {
    tutorial: (state) => state.tutorial,
    areTutorialsFinished: (state) => state.tutorialsFinished,
    isTutorialActive: (state) => (tutorial) => state.tutorial === tutorial,

    tutorialTextCurrentId: (state) => state.currentText,
    tutorialTextCurrent: (_state, getters) => TextTutorialsManager.getById(getters.tutorialTextCurrentId!),
    tutorialTextPosition: (state) => state.currentTextPosition,
    tutorialTextShown: (state) => state.shownText,
    wasTutorialTextShown: (_state, getters) => (id) => getters.tutorialTextShown.includes(id),
  },

  actions: {
    tutorialShow({ commit }, name) {
      commit('TUTORIAL_SHOW', name);
    },
    tutorialHide({ commit }) {
      commit('TUTORIAL_HIDE');
    },
    tutorialsFinished({ commit }) {
      commit('TUTORIALS_FINISHED');

      EventsManager.emit('TUTORIALS_FINISHED');
    },

    tutorialTextShow({ commit }, data) {
      commit('TUTORIAL_TEXT_SHOW', data);
    },
    tutorialTextHide({ commit }) {
      commit('TUTORIAL_TEXT_HIDE');
    },

    resetProgress({ commit }) {
      commit('TUTORIALS_TEXT_CLEAR');
      TextTutorialsManager.onReset();
    },
  },

  mutations: {
    TUTORIAL_SHOW(state, name) {
      state.tutorial = name;
      state.tutorialsFinished = false;
    },
    TUTORIAL_HIDE(state) {
      state.tutorial = null;
    },
    TUTORIALS_FINISHED(state) {
      state.tutorialsFinished = true;
    },

    TUTORIAL_TEXT_SHOW(state, { id, position }) {
      state.currentText = id;
      state.currentTextPosition = position;

      if (state.shownText.includes(id)) return;
      state.shownText.push(id);
    },
    TUTORIAL_TEXT_HIDE(state) {
      state.currentText = null;
      state.currentTextPosition = null;
    },
    TUTORIALS_TEXT_CLEAR(state) {
      state.currentText = null;
      state.currentTextPosition = null;
      state.shownText = [];
    },
  },
};

export default storeModule;
